import * as yup from 'yup'
import { IntlShape } from 'react-intl'

export interface FormValues {
  orderId: string
  lastname: string
  email: string
  comment: string
}

export const schema: FormValues = {
  orderId: '',
  lastname: '',
  email: '',
  comment: ''
}

export const validation = (
  intl: IntlShape
) => {
  const { formatMessage } = intl

  return (
    yup
      .object()
      .shape({
        orderId: yup
          .string()
          .required(formatMessage({ id: 'validation.genericRequired' })),

        lastname: yup
          .string()
          .required(formatMessage({ id: 'validation.genericRequired' })),

        email: yup
          .string()
          .required(formatMessage({ id: 'validation.genericRequired' })),

        comment: yup
          .string()
          .required(formatMessage({ id: 'validation.genericRequired' }))
      })
  )
}
